export class District {
  districtId: number;
  countyId: number;
  districtName: string;

  constructor(json?: any) {
    this.countyId = json.countyId;
    this.districtId = json.districtId;
    this.districtName = json.districtName;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/District.ts